import api from './api';
import { API_ENDPOINTS } from '../config/constants';

// Helper: Mandant-ID aus Context/Storage holen
const getMandantId = () => {
    const selectedTenant = localStorage.getItem('selectedTenant');
    if (selectedTenant) {
        const tenant = JSON.parse(selectedTenant);
        return tenant.mandant_id;
    }
    return null;
};

// Helper: Mandant-ID Header hinzufügen
const getHeaders = () => {
    const mandantId = getMandantId();
    if (!mandantId) {
        throw new Error('Kein Mandant ausgewählt');
    }
    return {
        'X-Mandant-Id': mandantId,
    };
};

// ==================== PROZESSE ====================

export const getProzesse = async () => {
    try {
        const response = await api.get(API_ENDPOINTS.SCHUTZBEDARFSANALYSE.PROZESSE, {
            headers: getHeaders(),
        });
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        console.error('Get Prozesse error:', error);
        return {
            success: false,
            error: error.response?.data?.detail || error.message || 'Fehler beim Laden der Prozesse',
        };
    }
};

export const createProzess = async (prozessData) => {
    try {
        const response = await api.post(
            API_ENDPOINTS.SCHUTZBEDARFSANALYSE.PROZESSE,
            prozessData,
            {
                headers: getHeaders(),
            }
        );
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        console.error('Create Prozess error:', error);
        return {
            success: false,
            error: error.response?.data?.detail || error.message || 'Fehler beim Erstellen des Prozesses',
        };
    }
};

export const updateProzess = async (prozessId, prozessData) => {
    try {
        const url = API_ENDPOINTS.SCHUTZBEDARFSANALYSE.PROZESS_BY_ID.replace(':id', prozessId);
        const response = await api.put(url, prozessData, {
            headers: getHeaders(),
        });
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        console.error('Update Prozess error:', error);
        return {
            success: false,
            error: error.response?.data?.detail || error.message || 'Fehler beim Aktualisieren des Prozesses',
        };
    }
};

export const deleteProzess = async (prozessId) => {
    try {
        const url = API_ENDPOINTS.SCHUTZBEDARFSANALYSE.PROZESS_BY_ID.replace(':id', prozessId);
        await api.delete(url, {
            headers: getHeaders(),
        });
        return {
            success: true,
        };
    } catch (error) {
        console.error('Delete Prozess error:', error);
        return {
            success: false,
            error: error.response?.data?.detail || error.message || 'Fehler beim Löschen des Prozesses',
        };
    }
};

// ==================== ANALYSEN ====================

export const getAnalysen = async (prozessId = null) => {
    try {
        const params = prozessId ? { prozess_id: prozessId } : {};
        const response = await api.get(API_ENDPOINTS.SCHUTZBEDARFSANALYSE.ANALYSEN, {
            headers: getHeaders(),
            params,
        });
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        console.error('Get Analysen error:', error);
        return {
            success: false,
            error: error.response?.data?.detail || error.message || 'Fehler beim Laden der Analysen',
        };
    }
};

export const createAnalyse = async (analyseData) => {
    try {
        const response = await api.post(
            API_ENDPOINTS.SCHUTZBEDARFSANALYSE.ANALYSEN,
            analyseData,
            {
                headers: getHeaders(),
            }
        );
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        console.error('Create Analyse error:', error);
        return {
            success: false,
            error: error.response?.data?.detail || error.message || 'Fehler beim Erstellen der Analyse',
        };
    }
};

export const updateAnalyse = async (analyseId, analyseData) => {
    try {
        const url = API_ENDPOINTS.SCHUTZBEDARFSANALYSE.ANALYSE_BY_ID.replace(':id', analyseId);
        const response = await api.put(url, analyseData, {
            headers: getHeaders(),
        });
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        console.error('Update Analyse error:', error);
        return {
            success: false,
            error: error.response?.data?.detail || error.message || 'Fehler beim Aktualisieren der Analyse',
        };
    }
};

// ==================== RISIKEN ====================

export const getRisiken = async (analyseId = null) => {
    try {
        const params = analyseId ? { analyse_id: analyseId } : {};
        const response = await api.get(API_ENDPOINTS.SCHUTZBEDARFSANALYSE.RISIKEN, {
            headers: getHeaders(),
            params,
        });
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        console.error('Get Risiken error:', error);
        return {
            success: false,
            error: error.response?.data?.detail || error.message || 'Fehler beim Laden der Risiken',
        };
    }
};

export const createRisiko = async (risikoData) => {
    try {
        const response = await api.post(
            API_ENDPOINTS.SCHUTZBEDARFSANALYSE.RISIKEN,
            risikoData,
            {
                headers: getHeaders(),
            }
        );
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        //console.error('Create Risiko error:', error);
        return {
            success: false,
            error: error.response?.data?.detail || error.message || 'Fehler beim Erstellen des Risikos',
        };
    }
};

export const updateRisiko = async (risikoId, risikoData) => {
    try {
        const url = API_ENDPOINTS.SCHUTZBEDARFSANALYSE.RISIKO_BY_ID.replace(':id', risikoId);
        const response = await api.put(url, risikoData, {
            headers: getHeaders(),
        });
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        console.error('Update Risiko error:', error);
        return {
            success: false,
            error: error.response?.data?.detail || error.message || 'Fehler beim Aktualisieren des Risikos',
        };
    }
};

export const deleteRisiko = async (risikoId) => {
    try {
        const url = API_ENDPOINTS.SCHUTZBEDARFSANALYSE.RISIKO_BY_ID.replace(':id', risikoId);
        await api.delete(url, {
            headers: getHeaders(),
        });
        return {
            success: true,
        };
    } catch (error) {
        console.error('Delete Risiko error:', error);
        return {
            success: false,
            error: error.response?.data?.detail || error.message || 'Fehler beim Löschen des Risikos',
        };
    }
};

// ==================== MAßNAHMEN ====================

export const getMassnahmen = async (risikoId = null) => {
    try {
        const params = risikoId ? { risiko_id: risikoId } : {};
        const response = await api.get(API_ENDPOINTS.SCHUTZBEDARFSANALYSE.MASSNAHMEN, {
            headers: getHeaders(),
            params,
        });
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        console.error('Get Maßnahmen error:', error);
        return {
            success: false,
            error: error.response?.data?.detail || error.message || 'Fehler beim Laden der Maßnahmen',
        };
    }
};

export const createMassnahme = async (massnahmeData) => {
    try {
        const response = await api.post(
            API_ENDPOINTS.SCHUTZBEDARFSANALYSE.MASSNAHMEN,
            massnahmeData,
            {
                headers: getHeaders(),
            }
        );
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        console.error('Create Maßnahme error:', error);
        return {
            success: false,
            error: error.response?.data?.detail || error.message || 'Fehler beim Erstellen der Maßnahme',
        };
    }
};

export const updateMassnahme = async (massnahmeId, massnahmeData) => {
    try {
        const url = API_ENDPOINTS.SCHUTZBEDARFSANALYSE.MASSNAHME_BY_ID.replace(':id', massnahmeId);
        const response = await api.put(url, massnahmeData, {
            headers: getHeaders(),
        });
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        console.error('Update Maßnahme error:', error);
        return {
            success: false,
            error: error.response?.data?.detail || error.message || 'Fehler beim Aktualisieren der Maßnahme',
        };
    }
};

export const deleteMassnahme = async (massnahmeId) => {
    try {
        const url = API_ENDPOINTS.SCHUTZBEDARFSANALYSE.MASSNAHME_BY_ID.replace(':id', massnahmeId);
        await api.delete(url, {
            headers: getHeaders(),
        });
        return {
            success: true,
        };
    } catch (error) {
        console.error('Delete Maßnahme error:', error);
        return {
            success: false,
            error: error.response?.data?.detail || error.message || 'Fehler beim Löschen der Maßnahme',
        };
    }
};

// ==================== ANWENDUNGEN ====================

export const getAnwendungen = async () => {
    try {
        const response = await api.get(
            API_ENDPOINTS.SCHUTZBEDARFSANALYSE.ANWENDUNGEN,
            {
                headers: getHeaders(),
            }
        );
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        console.error('Get Anwendungen error:', error);
        return {
            success: false,
            error: error.response?.data?.detail || error.message || 'Fehler beim Laden der Anwendungen',
        };
    }
};

export const createAnwendung = async (anwendungData) => {
    try {
        const response = await api.post(
            API_ENDPOINTS.SCHUTZBEDARFSANALYSE.ANWENDUNGEN,
            anwendungData,
            {
                headers: getHeaders(),
            }
        );
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        console.error('Create Anwendung error:', error);
        return {
            success: false,
            error: error.response?.data?.detail || error.message || 'Fehler beim Erstellen der Anwendung',
        };
    }
};

export const updateAnwendung = async (anwendungId, anwendungData) => {
    try {
        const response = await api.put(
            `${API_ENDPOINTS.SCHUTZBEDARFSANALYSE.ANWENDUNGEN}/${anwendungId}`,
            anwendungData,
            {
                headers: getHeaders(),
            }
        );
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        console.error('Update Anwendung error:', error);
        return {
            success: false,
            error: error.response?.data?.detail || error.message || 'Fehler beim Aktualisieren der Anwendung',
        };
    }
};

export const deleteAnwendung = async (anwendungId) => {
    try {
        const response = await api.delete(
            `${API_ENDPOINTS.SCHUTZBEDARFSANALYSE.ANWENDUNGEN}/${anwendungId}`,
            {
                headers: getHeaders(),
            }
        );
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        console.error('Delete Anwendung error:', error);
        return {
            success: false,
            error: error.response?.data?.detail || error.message || 'Fehler beim Löschen der Anwendung',
        };
    }
};

// ==================== ANWENDUNGSANALYSEN ====================

export const getAnwendungsanalysen = async (anwendungId = null) => {
    try {
        const params = anwendungId ? { anwendung_id: anwendungId } : {};
        const response = await api.get(API_ENDPOINTS.SCHUTZBEDARFSANALYSE.ANWENDUNGSANALYSEN, {
            headers: getHeaders(),
            params,
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('Get Anwendungsanalysen error:', error);
        return { success: false, error: error.response?.data?.detail || error.message || 'Fehler beim Laden der Anwendungsanalysen' };
    }
};

export const createAnwendungsanalyse = async (analyseData) => {
    try {
        const response = await api.post(API_ENDPOINTS.SCHUTZBEDARFSANALYSE.ANWENDUNGSANALYSEN, analyseData, {
            headers: getHeaders(),
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('Create Anwendungsanalyse error:', error);
        return { success: false, error: error.response?.data?.detail || error.message || 'Fehler beim Erstellen der Anwendungsanalyse' };
    }
};

export const updateAnwendungsanalyse = async (analyseId, analyseData) => {
    try {
        const url = API_ENDPOINTS.SCHUTZBEDARFSANALYSE.ANWENDUNGSANALYSE_BY_ID.replace(':id', analyseId);
        const response = await api.put(url, analyseData, {
            headers: getHeaders(),
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('Update Anwendungsanalyse error:', error);
        return { success: false, error: error.response?.data?.detail || error.message || 'Fehler beim Aktualisieren der Anwendungsanalyse' };
    }
};
